import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const QuickActions = ({ onNewShipment, onTrackShipment }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      <div className="bg-card rounded-lg border border-border shadow-warm p-6 hover:shadow-lg transition-shadow">
        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
            <Icon name="Package" size={24} color="white" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-heading font-bold text-foreground mb-1">
              Create New Shipment
            </h3>
            <p className="text-sm font-body text-muted-foreground mb-3">
              Start a new shipping order with our easy booking system
            </p>
            <Button
              variant="default"
              size="sm"
              iconName="Plus"
              iconPosition="left"
              onClick={onNewShipment}
              fullWidth
            >
              New Shipment
            </Button>
          </div>
        </div>
      </div>

      <div className="bg-card rounded-lg border border-border shadow-warm p-6 hover:shadow-lg transition-shadow">
        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
            <Icon name="MapPin" size={24} color="white" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-heading font-bold text-foreground mb-1">
              Track Your Package
            </h3>
            <p className="text-sm font-body text-muted-foreground mb-3">
              Get real-time updates on your shipment location
            </p>
            <Button
              variant="outline"
              size="sm"
              iconName="Search"
              iconPosition="left"
              onClick={onTrackShipment}
              fullWidth
            >
              Track Shipment
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;